import React, { Component } from 'react';
import { Row, Col } from 'react-materialize';
import { FormattedMessage } from 'react-intl';

import Logger from '../functions/logging';

import '../static/DestinationPrompt.css';
import actionableInsightsImage from '../assets/destination-prompt/actionable-insights.png';
import whoLovesYourShowImage from '../assets/destination-prompt/who-loves-your-show.png';
import LandingHeader from '../components/landing/LandingHeader';
import { connect } from 'react-redux';
import * as actions from '../redux/actions/index';

/* Google analytics */
import ActionStatus from '../analytics/analytics-events/ActionStatus';
import { ActionStatusEvent } from '../analytics/analytics-events/constants';

const LANDING = 'landing';

class DestinationPrompt extends Component {

	handleGiveFeedbackClick = () => {
		// this.props.setCookie('show_landing', true, 1);
		this.props.updateRenderState(LANDING);

		let actionStatus = new ActionStatus(ActionStatusEvent.GIVE_FEEDBACK, '', '', false, false, true);
		actionStatus.gaTracker = this.props.tracker;
		this.props.globalAnalyticsAdapter.reportAnalyticsEvent(actionStatus);	
	};

	handleGetFeedbackClick = () => {
		let actionStatus = new ActionStatus(ActionStatusEvent.GET_FEEDBACK, '', '', false, false, true);
		actionStatus.gaTracker = this.props.tracker;
		this.props.globalAnalyticsAdapter.reportAnalyticsEvent(actionStatus);	
	}

	render() {
		Logger.log(this.constructor.name, "render()", this.props, this.state);
		
		return (
			<div className='dp-main-container'>
				<LandingHeader history={this.props.history} styles={{ background: '#2280BD', position: 'unset' }} disableScroll={true} />
				
				<div className='dp-instructions'>
					<FormattedMessage
						id="destination_prompt.choose"
						defaultMessage={`Choose what you're interested in`}
					/>
				</div>

				<Row style={{ background: '#2280BD' }} className='valign-wrapper dp-container mb-0'>
					<div className='dp-seperator-container'>
					</div>
					<Col s={12} m={5} l={5}>
						<Row className='destination-button' onClick={this.handleGiveFeedbackClick}>
							{/* Add a link here again */}
							<Col s={12}>
								<div className='dp-title-container'>
									<p className='dp-give-text'>
										<FormattedMessage
											id="destination_prompt.give_feedback.give"
											defaultMessage={`Give`}
										/>
									</p>
									<p className='dp-feedback-text'>
										<FormattedMessage
											id="destination_prompt.give_feedback.feedback"
											defaultMessage={`Feedback`}
										/>
									</p>
								</div>
							</Col>

							<Col className='' s={12}>
								<div className='dp-image-container'>
									<img className='dp-image' src={whoLovesYourShowImage} alt='Who Loves Your Show' />
								</div>
							</Col>

							<Col s={12}>
								<p className='center-align dp-description-text'>									
									<FormattedMessage
										id="destination_prompt.give_feedback.body"
										defaultMessage={`Watch exclusive videos and give your opinion to earn rewards`}
									/>
								</p>
							</Col>
						
						</Row>
					</Col>

					<Col s={12} m={2} l={2}>
						<div className='dp-seperator-container'>
							<div className='dp-seperator' />
						</div>
					</Col>

					<Col s={12} m={5} l={5}>
						<Row onClick={this.handleGetFeedbackClick} className='destination-button'>
							<a href='https://www.pilot.ly/'>
								<Col s={12}>
									<div className='dp-title-container'>
										<p className='dp-give-text'>
											<FormattedMessage
												id="destination_prompt.get_feedback.get"
												defaultMessage={`Get`}
											/>
										</p>
										<p className='dp-feedback-text'>
											<FormattedMessage
												id="destination_prompt.get_feedback.feedback"
												defaultMessage={`Feedback`}
											/>
										</p>
									</div>
								</Col>

								<Col className='valign-wrapper' s={12}>
									<div className='dp-image-container'>
										<img className='dp-image' src={actionableInsightsImage} alt='Actionable Insights' />
									</div>
								</Col>

								<Col s={12}>
									<p className='center-align dp-description-text'>
										<FormattedMessage
											id="destination_prompt.get_feedback.body"
											defaultMessage={`Screen your content to our community to gain insight`}
										/>
									</p>
								</Col>
							</a>
						</Row>
					</Col>
				</Row>
			</ div>
		);
	}
}

const mapStateToProps = state => ({
	tracker: state.GlobalAnalyticsAdapterReducer.gaTracker,
	globalAnalyticsAdapter: state.GlobalAnalyticsAdapterReducer.globalAnalyticsAdapter,	
});

export default connect(mapStateToProps, actions)(DestinationPrompt);


// WEBPACK FOOTER //
// ./src/pages/DestinationPrompt.js